export const assistantKeys = {
  all: ['assistant'] as const,
  conversations: () => [...assistantKeys.all, 'conversations'] as const,
  messages: (conversationId: string) =>
    [...assistantKeys.all, 'messages', conversationId] as const,
  uploads: (conversationId: string) =>
    [...assistantKeys.all, 'uploads', conversationId] as const,
};

export const CONTENT_QUERY_KEYS = [
  ['courses'],
  ['modules'],
  ['course-modules'],
  ['lessons'],
  ['lesson'],
] as const;
